import { formatDecimal } from "./formatting";

/* [sc-49019] Totale di una riga di preventivo, IVA esclusa: prezzo netto
   applicato × quantità effettiva della riga (pezzi, o mq/ml per gli articoli a
   superficie e lineari, dove il prezzo è al mq/ml). Imponibile come il prezzo
   unitario che gli sta accanto in tabella, così il conto si rifà a occhio
   (25,00 × 5 = 125,00) — scelto con Andrea il 2026-10-08. Il PDF e il totale
   di suddivisione restano ivati.

   Arrotondato al centesimo: 0,1 × 3 in virgola mobile non fa 0,30. */
export function totaleRigaImponibile(prezzo, quantita) {
  const p = Number(prezzo);
  const q = Number(quantita);
  if (!Number.isFinite(p) || !Number.isFinite(q)) return 0;
  return Math.round(p * q * 100) / 100;
}

export function totaleRigaImponibileFormattato(prezzo, quantita) {
  return `€ ${formatDecimal(totaleRigaImponibile(prezzo, quantita))}`;
}
